<form method="POST" action="http://localhost/status">
    <label for="parcelId">{{lang.insertShipNumber}}<br><br></label>
    <input  [(ngModel)]="shipmentNumber" name="parcelId" class="form-input" type="text" placeholder="{{lang.insertShipNumberPlaceholder}}"/><br><br>
    <button (click)="searchItem(shipmentNumber)">{{lang.showStatusButton}}</button>
</form>

<p *ngIf="wrongInput" [innerHTML]="lang.badInput"></p>
